import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'luci-loader',
  templateUrl: './luci-loader.component.html',
  styleUrls: ['./luci-loader.component.scss']
})
export class LuciLoaderComponent implements OnInit {
  @Input() message = '';
  @Input() showText = false;
  @Input() theme = '';
  @Input() isBackDrop = false;
  @Input() size = '';
  @Input() thickness = '';
  @Input() textOrientation = '';
  @Input() type = ''; // inline,internal,external
  @Input () componentLoader = false;

  constructor() {
    this.type = 'external';
  }

  ngOnInit() {

  }

  setSpinnerStyles(theme, thickness) {
    let color = 'strip-default ';
    let thick = 'spinner-neutral ';

    if (theme === 'green') {
      color = 'strip-green';
    } else if (theme === 'red') {
      color = 'strip-red';
    } else if (theme === 'yellow') {
      color = 'strip-yellow';
    }

    if (thickness === 'skinny') {
      thick = 'spinner-skinny';
    } else if (thickness === 'fat') {
      thick = 'spinner-fat';
    }
    return color + ' ' + thick;
  }

}
